import React from "react";

import Header from "../../contruction-home/components/Header";
import Footer from "../../contruction-home/components/Footer";
import Hero from "../../contruction-home/components/Hero";
import GetStarted from "../../contruction-home/components/GetStarted";
import NormalUserLayout from "../../layouts/NormalUserLayout/NormalUserLayout";

const Contacts = () => {
  return (
    <div className="ConstructionHome">
      <NormalUserLayout>
        <Header />
        <main className="main">
          {/* <div style={{ background: "rgba(0, 0, 0, 1)" }}> */}
          <Hero compact />
          <GetStarted />
        </main>
        <Footer />
      </NormalUserLayout>
    </div>
  );
};

export default Contacts;
